export default "__VITE_ASSET__CFh2viva__"